import React, { useState, useEffect } from 'react';
import "./Header.css";

const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`header ${scrolled ? 'scrolled' : ''}`}>
            <div className='logo-container'>
                <div className='logo-hex-small'>
                    <span>S</span>
                </div>
                <span className="logo-text">INGENIEUR LOGICIEL & ARCHITECTE<span className='dot'>.</span></span>
            </div>
            
            <ul className='nav-links'>
                <li><a href="#about" className="nav-item">SYSTÈME</a></li>
                <li><a href="#projects" className="nav-item">PROJETS</a></li>
                <li><a href="#contacts" className="cta-button-cyber">LIAISON</a></li>
            </ul>
        </nav>
    );
};

export default Header;